import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import Select from 'react-select'
import Button from '@material-ui/core/Button'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import TextField from '@material-ui/core/TextField'
import { CircularProgress } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Icon from '@material-ui/core/Icon'
import gql from 'graphql-tag'
import { Query, Mutation } from 'react-apollo'
import getLoginId from '../../../utils/getLoginId'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import {
  convertUIToDBSolutions,
  convertDBToUISolutions
} from './solutionTypeMapping'


const SolutionTypeOption = props => {
  const { onSelect, onFocus, isSelected, option, children, className } = props
  const handleMouseDown = event => {
    event.preventDefault()
    event.stopPropagation()
    onSelect(option, event)
  }
  const handleMouseEnter = event => {
    onFocus(option, event)
  }

  return (
    <div
      className={className}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseEnter}
      title={option.title}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <Checkbox checked={!!isSelected} color="primary" />
      <span>{children}</span>
    </div>
  )
}

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      loginId
    }
  }
`

const GET_DASHCAM_REGISTRATIONS = gql`
  query GetDashcamRegistrations {
    getDashcamRegistrations {
      success
      message
      data {
        uuid
        simid
        memorycardid
        uniqueid
        vtid
        status
        createdat
        updatedat
      }
    }
  }
`

const GET_VEHICLES = gql`
  query getAllVehicleDetails($clientLoginId: Int) {
    getAllVehicleDetails(clientLoginId: $clientLoginId) {
      entityId
      vehicleNumber
      solution_type
      deviceDetail {
        uniqueDeviceId
      }
      simDetail {
        id
        phoneNumber
      }
      videoTelematicsType
      videoTelematicsId
    }
  }
`





const GET_SOLUTION_TYPES = gql`
  query GetAllMasterSolutionType {
    getAllMasterSolutionType {
      id
      solutionTypeName
    }
  }
`

const GET_SOLUTION_TYPES_WITH_PLANS = gql`
  query GetAllSolutionTypes($clientCategory: ClientCategory, $clientLoginId: Int) {
    getAllSolutionTypes(
      clientCategory: $clientCategory
      clientLoginId: $clientLoginId
    ) {
      id
      solution_type_name
      description
      solutionTypeCategory
      plans {
        id
        planName
        planTypeId
        durationInYears
        durationInMonths
        durationLabel
        description
        basePrice
        discount
        perMonthBaseValue
        perMonthDiscountedValue
        isPopular
      }
    }
  }
`

const ADD_DEVICE_TOP = gql`
  mutation AddDeviceTop(
    $clientLoginId: Int
    $uniqueDeviceId: String
    $existingSolutionType: String
    $newSolutionType: String
    $planDuration: String
    $vehicledeviceid: Int
    $vt_created_by: String
    $created_by: String
    $updated_by: String
    $newSimId: Int
    $loginType: String
  ) {
    addDeviceTop(
      clientLoginId: $clientLoginId
      uniqueDeviceId: $uniqueDeviceId
      existingSolutionType: $existingSolutionType
      newSolutionType: $newSolutionType
      planDuration: $planDuration
      vehicledeviceid: $vehicledeviceid
      vt_created_by: $vt_created_by
      created_by: $created_by
      updated_by: $updated_by
      newSimId: $newSimId
      loginType: $loginType
    ) {
      success
      message
    }
  }
`

// Query to fetch available devices assigned to the selected customer
const GET_AVAILABLE_DEVICES = gql`
  query getAllAssignedDevicesToClient($clientId: Int!) {
    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {
      uniqueDeviceId
      deviceModel {
        model_name
      }
    }
  }
`

// Query to fetch available SIMs (phone numbers) assigned to the selected customer
const GET_AVAILABLE_SIMS = gql`
  query getAllAssignedSimToClient($clientId: Int!) {
    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {
      id
      simId
      sim {
        phoneNumber
      }
    }
  }
`

const styles = theme => ({
  root: {
    padding: 24,
    marginTop: 24,
    backgroundColor: '#fafafa',
    minHeight: '100vh'
  },
  paper: {
    padding: 24,
    marginBottom: 20,
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  formControl: {
    marginTop: 8,
    width: '100%'
  },
  selectBox: {
    width: '100%'
  },
  button: {
    marginLeft: 10,
    minWidth: 140,
    height: 40
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: 16,
    color: '#2c3e50'
  },
  vehicleCard: {
    background: '#ffffff',
    padding: 16,
    borderRadius: 8,
    border: '1px solid #e0e0e0',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': { borderBottom: 'none' }
  },
  infoLabel: {
    fontWeight: 600,
    color: '#555',
    minWidth: 160,
    fontSize: 13
  },
  infoValue: {
    color: '#222',
    fontSize: 13
  },
  solutionChip: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: 20,
    background: '#e3f2fd',
    color: '#1565c0',
    border: '1px solid #90caf9',
    marginRight: 6,
    marginTop: 4,
    fontSize: 12,
    fontWeight: 500
  },
  planCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 16px',
    background: '#f1f8e9',
    border: '1px solid #aed581',
    borderRadius: 6
  },
  submitBtn: {
    minWidth: 150,
    height: 40,
    backgroundColor: '#1976d2',
    color: '#fff',
    '&:hover': { backgroundColor: '#1565c0' },
    '&:disabled': { backgroundColor: '#bdbdbd', color: '#fff' }
  },
  cancelBtn: {
    minWidth: 120,
    height: 40,
    marginRight: 10
  }
})

class DeviceTopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      topupMode: 'single',
      videoTelematicsType: [
        { label: 'LocoNav', value: 'loconav' },
        { label: 'MettaX', value: 'mettax' }
      ],
      selectedVTM: null,
      videoTelematicsId: '',
      selectedVtid: null,
      selectedSimId: '',
      selectedMemoryCardId: '',
      selectedCustomer: null,
      selectedVehicle: null,
      selectedSolutionTypes: [],
      selectedPlan: { durationLabel: '1 Year' },
      selectedNewDevice: null,
      selectedNewSimId: null,
      existingSubscriptions: [],
      loading: false,
      alertDialogOpen: false,
      alertDialogMessage: '',
      alertDialogTitle: ''
    }
  }

  // Helper: check if the new solution types require device replacement
  // according to backend rules:
  // 1) new solution includes "obd_solution" or "obd_fuel+fuel_solution" -> replace
  // 2) new solution is "fuel_solution" alone AND existing has no OBD -> replace
  isDeviceReplacementRequired = (existingSolutions, newSolutionCodes) => {
    if (!existingSolutions || !newSolutionCodes || newSolutionCodes.length === 0) return false

    const hasObd = (arr) => {
      return arr.includes('obd_solution') ||
             arr.includes('obd_fuel+fuel_solution')
    }

    const existingHasObd = hasObd(existingSolutions)
    const newHasObd = hasObd(newSolutionCodes)
    const newHasFuelOnly = newSolutionCodes.includes('fuel_solution') && !newHasObd

    return newHasObd || (newHasFuelOnly && !existingHasObd)
  }

  handleCustomerChange = (selectedCustomer) => {
    this.setState({
      selectedCustomer,
      selectedVehicle: null,
      selectedSolutionTypes: [],
      selectedNewDevice: null,
      selectedNewSimId: null,
      existingSubscriptions: []
    })
  }

  handleVehicleChange = (selectedVehicle) => {
    this.setState({
      selectedVehicle,
      selectedSolutionTypes: [],
      selectedNewDevice: null,
      selectedNewSimId: null,
      existingSubscriptions: []
    })
  }

  handleSolutionTypeChange = (selectedSolutionTypes) => {
    console.log('Solution type change triggered:', selectedSolutionTypes)
    const selectedCodes = selectedSolutionTypes ? selectedSolutionTypes.map(option => option.code) : []
    console.log('Extracted codes:', selectedCodes)
    this.setState({
      selectedSolutionTypes: selectedCodes,
      selectedNewDevice: null,
      selectedNewSimId: null
    })
  }

  handlePlanChange = (selectedPlan) => {
    this.setState({ selectedPlan })
  }

  handleNewDeviceChange = (selectedOption) => {
    this.setState({ selectedNewDevice: selectedOption })
  }

  handleNewSimChange = (selectedOption) => {
    this.setState({ selectedNewSimId: selectedOption ? selectedOption.value : null })
  }

  handleSubmit = (addDeviceTop) => {
    const {
      selectedCustomer,
      selectedVehicle,
      selectedSolutionTypes,
      selectedPlan,
      selectedVTM,
      selectedVtid,
      videoTelematicsId,
      topupMode,
      selectedNewDevice,
      selectedNewSimId
    } = this.state

    // Validation
    if (
      !selectedCustomer ||
      !selectedVehicle ||
      !selectedSolutionTypes ||
      selectedSolutionTypes.length === 0 ||
      !selectedPlan
    ) {
      this.setState({
        alertDialogOpen: true,
        alertDialogTitle: 'Validation Error',
        alertDialogMessage: 'Please fill all required fields'
      })
      return
    }

    // Existing solution type
    const existingSolutionType = Array.isArray(selectedVehicle.solution_type)
      ? selectedVehicle.solution_type.join(',')
      : selectedVehicle.solution_type || ''

    // Convert UI solution codes → DB format
    let newSolutionType = selectedSolutionTypes.join("+");
    if (newSolutionType === "obd_fuel+fuel_solution") {
      newSolutionType = "obd_solution+fuel_solution"
    }

    // Determine if device replacement is needed (only for non-VT topup)
    let needsReplacement = false
    if (topupMode !== 'vt') {
      const existingSolutions = Array.isArray(selectedVehicle.solution_type)
        ? selectedVehicle.solution_type
        : (selectedVehicle.solution_type ? [selectedVehicle.solution_type] : [])
      needsReplacement = this.isDeviceReplacementRequired(existingSolutions, selectedSolutionTypes)
    }

    // For VT topup, uniqueDeviceId will be set to VT ID
    // For normal topup, if replacement needed and new device selected, use that; else use existing device ID
    let uniqueDeviceId = ''
    if (topupMode === 'vt') {
      if (selectedVTM && selectedVTM.value === 'mettax' && selectedVtid) {
        uniqueDeviceId = selectedVtid.value
      } else if (selectedVTM && selectedVTM.value === 'loconav' && videoTelematicsId) {
        uniqueDeviceId = videoTelematicsId
      } else {
        this.setState({
          alertDialogOpen: true,
          alertDialogTitle: 'Validation Error',
          alertDialogMessage: 'Please select VT device details'
        })
        return
      }
    } else {
      // Normal topup (single/combo)
      if (needsReplacement) {
        if (!selectedNewDevice || !selectedNewSimId) {
          this.setState({
            alertDialogOpen: true,
            alertDialogTitle: 'Validation Error',
            alertDialogMessage: 'Please select a replacement device and SIM for the solution upgrade'
          })
          return
        }
        uniqueDeviceId = selectedNewDevice.value
      } else {
        // Use existing device ID from vehicle
        uniqueDeviceId =
          selectedVehicle.deviceDetail && selectedVehicle.deviceDetail.uniqueDeviceId
            ? selectedVehicle.deviceDetail.uniqueDeviceId
            : ''
      }
    }

    const planDuration = selectedPlan.durationLabel || ''

    let vtCreatedBy = null
    if (topupMode === 'vt') {
      vtCreatedBy = localStorage.getItem('username') || ''
    }

    // Mutation call
    addDeviceTop({
      variables: {
        clientLoginId: selectedCustomer.value,
        uniqueDeviceId: uniqueDeviceId,
        existingSolutionType: existingSolutionType,
        newSolutionType: newSolutionType,
        planDuration: planDuration,
        vehicledeviceid: parseInt(selectedVehicle.entityId, 10),
        vt_created_by: vtCreatedBy,
        created_by: localStorage.getItem('username'),
        updated_by: localStorage.getItem('username'),
        newSimId: needsReplacement ? selectedNewSimId : null,
        loginType: localStorage.getItem('Account_type') || 'PA'
      }
    })
      .then((result) => {
        const { success, message } = result.data.addDeviceTop
        if (success) {
          this.setState({
            alertDialogOpen: true,
            alertDialogTitle: 'Success',
            alertDialogMessage: 'Topup submitted successfully!',
            topupMode: 'single',
            selectedCustomer: null,
            selectedVehicle: null,
            selectedSolutionTypes: [],
            selectedPlan: { durationLabel: '1 Year' },
            existingSubscriptions: [],
            selectedVTM: null,
            videoTelematicsId: '',
            selectedVtid: null,
            selectedSimId: '',
            selectedMemoryCardId: '',
            selectedNewDevice: null,
            selectedNewSimId: null
          })
        } else {
          this.setState({
            alertDialogOpen: true,
            alertDialogTitle: 'Error',
            alertDialogMessage: message || 'Failed to submit topup'
          })
        }
      })
      .catch((error) => {
        console.error('Topup Error:', error)

        const errorMessage = error.graphQLErrors && error.graphQLErrors.length > 0
          ? error.graphQLErrors[0].message
          : error.message || 'Failed to submit topup'

        this.setState({
          alertDialogOpen: true,
          alertDialogTitle: 'Error',
          alertDialogMessage: errorMessage
        })
      })
  }

  handleCancel = () => {
    this.setState({
      topupMode: 'single',
      selectedCustomer: null,
      selectedVehicle: null,
      selectedSolutionTypes: [],
      selectedPlan: { durationLabel: '1 Year' },
      existingSubscriptions: [],
      selectedVTM: null,
      videoTelematicsId: '',
      selectedVtid: null,
      selectedSimId: '',
      selectedMemoryCardId: '',
      selectedNewDevice: null,
      selectedNewSimId: null
    })
  }

  handleTopupModeChange = (event, topupMode) => {
    if (!topupMode) return
    this.setState({
      topupMode,
      selectedSolutionTypes: topupMode === 'vt' ? ['vt'] : [],
      selectedVTM: null,
      videoTelematicsId: '',
      selectedVtid: null,
      selectedSimId: '',
      selectedMemoryCardId: '',
      selectedCustomer: null,
      selectedVehicle: null,
      selectedPlan: { durationLabel: '1 Year' },
      existingSubscriptions: [],
      selectedNewDevice: null,
      selectedNewSimId: null
    })
  }

  handleVideoTelematicsMenuChange = selectedOption => {
    this.setState({
      selectedVTM: selectedOption,
      selectedVtid: null,
      selectedSimId: '',
      selectedMemoryCardId: '',
      videoTelematicsId: '',
      selectedSolutionTypes: ['video_telematics'] // IMPORTANT for VT topup
    })
  }

  handleVideoTelematicsIdChange = event => {
    this.setState({ videoTelematicsId: event.target.value })
  }

  handleVtidChange = selectedOption => {
    if (!selectedOption) {
      this.setState({
        selectedVtid: null,
        selectedSimId: '',
        selectedMemoryCardId: ''
      })
      return
    }

    this.setState({
      selectedVtid: selectedOption,
      selectedSimId: selectedOption.simid || '',
      selectedMemoryCardId: selectedOption.memorycardid || ''
    })
  }

  closeAlertDialog = () => {
    this.setState({ alertDialogOpen: false })
  }

  render() {
    const { classes } = this.props
    const {
      topupMode,
      videoTelematicsType,
      selectedVTM,
      videoTelematicsId,
      selectedVtid,
      selectedSimId,
      selectedMemoryCardId,
      selectedCustomer,
      selectedVehicle,
      selectedSolutionTypes,
      selectedPlan,
      selectedNewDevice,
      selectedNewSimId,
      existingSubscriptions,
      alertDialogOpen,
      alertDialogMessage,
      alertDialogTitle
    } = this.state

    const partnerLoginId = getLoginId()

    // Compute whether device replacement is needed for the current selection
    let needsReplacement = false
    let existingSolutions = []
    if (selectedVehicle && topupMode !== 'vt' && selectedSolutionTypes.length > 0) {
      existingSolutions = Array.isArray(selectedVehicle.solution_type)
        ? selectedVehicle.solution_type
        : (selectedVehicle.solution_type ? [selectedVehicle.solution_type] : [])
      needsReplacement = this.isDeviceReplacementRequired(existingSolutions, selectedSolutionTypes)
    }

    return (
      <div className={classes.root}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          style={{ fontWeight: 700, marginBottom: 20 }}
        >
          Solution Topup
        </Typography>

        <Paper className={classes.paper}>
          <Tabs
            value={topupMode}
            onChange={this.handleTopupModeChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab value="single" label="Single Topup" />
            <Tab value="combo" label="Combo Topup" />
            <Tab value="vt" label="VT Topup" />
          </Tabs>
        </Paper>

        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            {/* Customer Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} fullWidth>
                <FormGroup>
                  <Typography variant="subtitle1" gutterBottom>
                    Select Customer *
                  </Typography>
                  <Query query={GET_CLIENTS} variables={{ partnerLoginId }}>
                    {({ loading, error, data }) => {
                      if (loading) return <CircularProgress size={24} />
                      if (error) return <div>Error loading customers</div>

                      const customerOptions = data.clients.map(client => ({
                        value: client.loginId,
                        label: client.clientName,
                        ...client
                      }))

                      return (
                        <Select
                          value={selectedCustomer}
                          onChange={this.handleCustomerChange}
                          options={customerOptions}
                          placeholder="Select a customer"
                          className={classes.selectBox}
                        />
                      )
                    }}
                  </Query>
                </FormGroup>
              </FormControl>
            </Grid>

            {/* Vehicle Dropdown */}
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} fullWidth>
                <FormGroup>
                  <Typography variant="subtitle1" gutterBottom>
                    Select Vehicle *
                  </Typography>
                  {selectedCustomer ? (
                    <Query query={GET_VEHICLES} variables={{ clientLoginId: selectedCustomer.value }}>
                      {({ loading, error, data }) => {
                        if (loading) return <CircularProgress size={24} />
                        if (error) return <div>Error loading vehicles</div>

                        const vehicleOptions = data.getAllVehicleDetails.map(vehicle => ({
                          value: vehicle.entityId,
                          label: vehicle.vehicleNumber,
                          ...vehicle
                        }))

                        return (
                          <Select
                            value={selectedVehicle}
                            onChange={this.handleVehicleChange}
                            options={vehicleOptions}
                            placeholder="Select a vehicle"
                            className={classes.selectBox}
                          />
                        )
                      }}
                    </Query>
                  ) : (
                    <div style={{ color: '#666', padding: '8px' }}>
                      Please select a customer first
                    </div>
                  )}
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        {/* Existing Subscriptions */}
        {selectedVehicle && (
          <Paper className={classes.paper}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Vehicle Details
            </Typography>

            <Query
              query={GET_VEHICLES}
              variables={{ clientLoginId: selectedCustomer.value }}
            >
              {({ loading, error, data }) => {
                if (loading) return <CircularProgress size={24} />
                if (error) return <div>Error loading vehicle details</div>

                const selectedVehicleData = data.getAllVehicleDetails.find(
                  vehicle => vehicle.entityId === selectedVehicle.value
                )

                if (!selectedVehicleData) {
                  return <div>No vehicle data found</div>
                }

                const deviceId =
                  selectedVehicleData.deviceDetail &&
                    selectedVehicleData.deviceDetail.uniqueDeviceId
                    ? selectedVehicleData.deviceDetail.uniqueDeviceId
                    : 'Not Installed'

                const solutionTypes = Array.isArray(selectedVehicleData.solution_type)
                  ? selectedVehicleData.solution_type
                  : []

                return (
                  <div className={classes.vehicleCard}>
                    <div className={classes.infoRow}>
                      <span className={classes.infoLabel}>Vehicle Number</span>
                      <span className={classes.infoValue}>{selectedVehicleData.vehicleNumber}</span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.infoLabel}>Device Unique ID</span>
                      <span className={classes.infoValue} style={{ fontFamily: 'monospace', fontSize: 12 }}>
                        {deviceId}
                      </span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.infoLabel}>Existing Solutions</span>
                      <span className={classes.infoValue}>
                        {solutionTypes.length > 0 ? (
                          solutionTypes.map((sol, i) => (
                            <span key={i} className={classes.solutionChip}>{sol}</span>
                          ))
                        ) : (
                          <span style={{ color: '#999', fontSize: 12 }}>No solutions assigned</span>
                        )}
                      </span>
                    </div>
                  </div>
                )
              }}
            </Query>
          </Paper>
        )}

        {/* New Solution Type Selection */}
        {selectedVehicle && (
          <Paper className={classes.paper}>
            <Typography variant="h6" gutterBottom>
              Add New Solution Type
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.formControl} fullWidth>
                  <FormGroup>
                    <Typography variant="subtitle1" gutterBottom>
                      Solution Type *
                    </Typography>
                    <Query query={GET_VEHICLES} variables={{ clientLoginId: selectedCustomer.value }}>
                      {({ loading: vehicleLoading, error: vehicleError, data: vehicleData }) => {
                        if (vehicleLoading) return <CircularProgress size={24} />
                        if (vehicleError) return <div>Error loading vehicle data</div>

                        // Get existing solution types for the selected vehicle
                        const selectedVehicleData = vehicleData.getAllVehicleDetails.find(
                          vehicle => vehicle.entityId === selectedVehicle.value
                        )
                        const existingSolutionTypes =
                          selectedVehicleData && Array.isArray(selectedVehicleData.solution_type)
                            ? selectedVehicleData.solution_type
                            : []

                        return (
                          <Query query={GET_SOLUTION_TYPES}>
                            {({ loading, error, data }) => {
                              if (loading) return <CircularProgress size={24} />
                              if (error) return <div>Error loading solution types</div>

                              const solutionTypeMultiOptions = data.getAllMasterSolutionType.map(type => {
                                const code = type.id

                                return {
                                  value: code, // Use the code as value for consistency
                                  label: type.solutionTypeName,
                                  code: code,
                                  id: type.id
                                }
                              })

                              const modeFilteredOptions = solutionTypeMultiOptions.filter(option => {
                                const isCombo = typeof option.id === 'string' && option.id.includes('+')
                                const isVt = option.id === 'video_telematics' || option.code === 'vt'

                                if (topupMode === 'single') return !isCombo && !isVt  
                                if (topupMode === 'combo') return isCombo
                                if (topupMode === 'vt') return isVt
                                return true
                              })

                              // Filter out already existing solution types
                              const availableOptions = modeFilteredOptions.filter(
                                option => !existingSolutionTypes.includes(option.code)
                              )

                              const selectedMultiValue = availableOptions.filter(
                                option =>
                                  selectedSolutionTypes &&
                                  selectedSolutionTypes.some(
                                    selectedVal =>
                                      option.code === selectedVal ||
                                      (option.code &&
                                        option.code.split(',').includes(selectedVal))
                                  )
                              )

                              console.log('Selected solution types from state:', selectedSolutionTypes)
                              console.log('Selected multi value:', selectedMultiValue)

                              if (availableOptions.length === 0) {
                                return (
                                  <div style={{ color: '#666', padding: '16px' }}>
                                    All solution types are already assigned to this vehicle
                                  </div>
                                )
                              }

                              return (
                                topupMode === 'vt' ? (
                                  selectedVehicleData && selectedVehicleData.videoTelematicsType && selectedVehicleData.videoTelematicsId ? (
                                    <div style={{ padding: '16px', background: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: '4px' }}>
                                      <Typography variant="subtitle1" style={{ color: '#2e7d32', fontWeight: 600 }}>
                                        Video Telematics Already Exists
                                      </Typography>
                                      <Typography variant="body2" style={{ color: '#1b5e20', marginTop: '8px' }}>
                                        <strong>Type:</strong> {selectedVehicleData.videoTelematicsType} <br/>
                                        <strong>ID:</strong> {selectedVehicleData.videoTelematicsId}
                                      </Typography>
                                    </div>
                                  ) : (
                                    <div>
                                      <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ marginRight: '10px', minWidth: '130px' }}>
                                          Video Telematics
                                        </div>
                                        <div style={{ flex: 1 }}>
                                          <Select
                                            options={videoTelematicsType}
                                            value={selectedVTM}
                                            onChange={this.handleVideoTelematicsMenuChange}
                                            placeholder="Select Video Telematics"
                                          />
                                        </div>
                                      </div>

                                      {selectedVTM && selectedVTM.value && (
                                        <div style={{ marginTop: '10px' }}>
                                          {selectedVTM.value === 'mettax' ? (
                                            <Query query={GET_DASHCAM_REGISTRATIONS} fetchPolicy="network-only">
                                              {({ loading: dashcamLoading, error: dashcamError, data: dashcamData }) => {
                                                if (dashcamLoading) return <CircularProgress size={30} />
                                                if (dashcamError) return <div>Error loading MettaX VT IDs</div>

                                                const rows =
                                                  dashcamData &&
                                                    dashcamData.getDashcamRegistrations &&
                                                    dashcamData.getDashcamRegistrations.success &&
                                                    Array.isArray(dashcamData.getDashcamRegistrations.data)
                                                    ? dashcamData.getDashcamRegistrations.data
                                                    : []

                                                const available = rows.filter(r => r.status === 'available')
                                                const vtidOptions = available
                                                  .filter(r => r && r.vtid)
                                                  .map(r => ({
                                                    label: r.vtid,
                                                    value: r.vtid,
                                                    simid: r.simid,
                                                    memorycardid: r.memorycardid
                                                  }))

                                                return (
                                                  <React.Fragment>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                      <div style={{ marginRight: '10px', minWidth: '130px' }}>
                                                        Mettax VT ID *
                                                      </div>
                                                      <div style={{ flex: 1 }}>
                                                        <Select
                                                          options={vtidOptions}
                                                          value={selectedVtid}
                                                          onChange={this.handleVtidChange}
                                                          placeholder="Select ID"
                                                        />
                                                      </div>
                                                    </div>

                                                    {selectedVtid && (
                                                      <Grid container spacing={2} style={{ marginTop: '10px' }}>
                                                        <Grid item xs={6}>
                                                          <TextField label="SIM ID" disabled value={selectedSimId} fullWidth />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                          <TextField
                                                            label="Memory Card"
                                                            disabled
                                                            value={selectedMemoryCardId}
                                                            fullWidth
                                                          />
                                                        </Grid>
                                                      </Grid>
                                                    )}
                                                  </React.Fragment>
                                                )
                                              }}
                                            </Query>
                                          ) : (
                                            <TextField
                                              label={`Video Telematics Id${selectedVTM ? '*' : ''}`}
                                              value={videoTelematicsId}
                                              onChange={this.handleVideoTelematicsIdChange}
                                              fullWidth
                                            />
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )
                                ) : (
                                  <Select
                                    id="solution_type"
                                    name="solution_type"
                                    options={availableOptions}
                                    value={selectedMultiValue}
                                    multi
                                    optionComponent={SolutionTypeOption}
                                    closeOnSelect={false}
                                    removeSelected={false}
                                    onChange={this.handleSolutionTypeChange}
                                    placeholder="Select additional solution types"
                                    className={classes.selectBox}
                                  />
                                )
                              )
                            }}
                          </Query>
                        )
                      }}
                    </Query>
                  </FormGroup>
                </FormControl>
              </Grid>

              {/* Plans Display */}
              {selectedSolutionTypes && selectedSolutionTypes.length > 0 && (
                <Grid item xs={12} sm={6}>
                  <FormControl className={classes.formControl} fullWidth>
                    <FormGroup>
                      <Typography variant="subtitle1" gutterBottom>
                        Plan Duration
                      </Typography>
                      <div className={classes.planCard}>
                        <Icon style={{ color: '#558b2f', fontSize: 20 }}>event_available</Icon>
                        <div>
                          <Typography variant="body1" style={{ fontWeight: 700, color: '#33691e' }}>
                            1 Year
                          </Typography>
                          <Typography variant="caption" style={{ color: '#558b2f' }}>
                            Standard subscription duration
                          </Typography>
                        </div>
                      </div>
                    </FormGroup>
                  </FormControl>
                </Grid>
              )}
            </Grid>

            {/* Conditional device+SIM replacement step (only when replacement needed) */}
            {needsReplacement && topupMode !== 'vt' && selectedCustomer && (
              <Grid container spacing={3} style={{ marginTop: 16 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl className={classes.formControl} fullWidth>
                    <FormGroup>
                      <Typography variant="subtitle1" gutterBottom>
                        Select New Device ID *
                      </Typography>
                      <Query
                        query={GET_AVAILABLE_DEVICES}
                        variables={{ clientId: selectedCustomer.value }}
                        fetchPolicy="network-only"
                      >
                        {({ loading: devicesLoading, error: devicesError, data: devicesData }) => {
                          if (devicesLoading) return <CircularProgress size={24} />
                          if (devicesError) return <div>Error loading available devices</div>

                          const devices = devicesData && devicesData.device ? devicesData.device : []
                          const deviceOptions = devices.map(device => ({
                            value: device.uniqueDeviceId,
                            label: device.uniqueDeviceId,
                            model: device.deviceModel ? device.deviceModel.model_name : null
                          }))

                          // Optionally exclude the current device ID from the list
                          const currentDeviceId = selectedVehicle && selectedVehicle.deviceDetail && selectedVehicle.deviceDetail.uniqueDeviceId
                          const filteredOptions = currentDeviceId
                            ? deviceOptions.filter(opt => opt.value !== currentDeviceId)
                            : deviceOptions

                          return (
                            <Select
                              value={selectedNewDevice}
                              onChange={this.handleNewDeviceChange}
                              options={filteredOptions}
                              placeholder="Choose a new device ID"
                              className={classes.selectBox}
                              isClearable
                            />
                          )
                        }}
                      </Query>
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl className={classes.formControl} fullWidth>
                    <FormGroup>
                      <Typography variant="subtitle1" gutterBottom>
                        Select New Phone Number *
                      </Typography>
                      <Query
                        query={GET_AVAILABLE_SIMS}
                        variables={{ clientId: selectedCustomer.value }}
                        fetchPolicy="network-only"
                      >
                        {({ loading: simsLoading, error: simsError, data: simsData }) => {
                          if (simsLoading) return <CircularProgress size={24} />
                          if (simsError) return <div>Error loading available SIMs</div>

                          const sims = simsData && simsData.simDetails ? simsData.simDetails : []
                          const simOptions = sims
                            .filter(sim => sim.sim)
                            .map(sim => ({
                              value: sim.simId,
                              label: sim.sim.phoneNumber
                            }))

                          const selectedSimOption = selectedNewSimId
                            ? simOptions.find(opt => opt.value === selectedNewSimId)
                            : null

                          return (
                            <Select
                              value={selectedSimOption}
                              onChange={this.handleNewSimChange}
                              options={simOptions}
                              placeholder="Choose a phone number"
                              className={classes.selectBox}
                              isClearable
                            />
                          )
                        }}
                      </Query>
                    </FormGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" style={{ color: '#f57c00' }}>
                    Note: Selected solution type requires replacing the Existing device Id. Replacing the device also requires replacing the SIM.
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Paper>
        )}

        {/* Action Buttons */}
        {selectedVehicle && (
          <Paper className={classes.paper}>
            <Grid container justify="flex-end" alignItems="center" spacing={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={this.handleCancel}
                  className={classes.cancelBtn}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Mutation mutation={ADD_DEVICE_TOP}>
                  {(addDeviceTop, { loading }) => (
                    <Button
                      variant="contained"
                      className={classes.submitBtn}
                      onClick={() => this.handleSubmit(addDeviceTop)}
                      disabled={
                        loading ||
                        !selectedCustomer ||
                        !selectedVehicle ||
                        !selectedSolutionTypes ||
                        selectedSolutionTypes.length === 0 ||
                        !selectedPlan ||
                        (needsReplacement && (!selectedNewDevice || !selectedNewSimId))
                      }
                    >
                      {loading
                        ? <CircularProgress size={20} style={{ color: '#fff' }} />
                        : 'Submit Topup'}
                    </Button>
                  )}
                </Mutation>
              </Grid>
            </Grid>
          </Paper>
        )}

        {/* Alert Dialog */}
        <ConfirmationalDialog
          isDialogOpen={alertDialogOpen}
          dialogTitle={alertDialogTitle}
          dialogMessage={alertDialogMessage}
          positiveResponseButtonText="OK"
          negativeResponseButtonText=""
          positiveResponseHandler={this.closeAlertDialog}
          negativeResponseHandler={this.closeAlertDialog}
          dialogCloseHandler={this.closeAlertDialog}
        />
      </div>
    )
  }
}

export default withStyles(styles)(DeviceTopup)



// WEBPACK FOOTER //
// ./src/components/Pages/DeviceTopup/index.jsx